import {
  ChangeDetectionStrategy,
  Component,
  TemplateRef,
  computed,
  contentChild,
  input,
  model,
} from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { TableModule } from 'primeng/table';
import { IconComponent } from '../icon/icon.component';
import { BadgeComponent } from '../badge/badge.component';
import type { PsCellContext, PsTableColumn } from './table.interfaces';

export type { PsCellContext, PsTableColumn };

@Component({
  selector: 'ps-table',
  standalone: true,
  imports: [TableModule, NgTemplateOutlet, IconComponent, BadgeComponent],
  templateUrl: './table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableComponent<Row extends object> {
  public readonly data = input.required<Row[]>();
  public readonly columns = input.required<PsTableColumn[]>();
  public readonly dataKey = input<string>('id');

  public readonly selection = model<Row[]>([]);
  public readonly expandedRows = model<Record<string, boolean>>({});

  public readonly rowHover = input(true);
  public readonly selectable = input(false);
  public readonly expandable = input(false);
  public readonly loading = input(false);
  public readonly emptyMessage = input('No records found.');

  protected readonly cellTemplate =
    contentChild<TemplateRef<PsCellContext<Row>>>('psCell');
  protected readonly expansionTemplate =
    contentChild<TemplateRef<{ $implicit: Row }>>('psExpansion');

  protected readonly colSpan = computed(() => {
    let total = this.columns().length;
    if (this.selectable()) total++;
    if (this.expandable()) total++;
    return total;
  });

  protected readonly tableClass = computed(() =>
    `ps-table ${this.rowHover() ? 'ps-table--hoverable' : ''}`.trim(),
  );

  protected expanderIcon(expanded: boolean): string {
    return expanded ? 'chevron-down' : 'chevron-right';
  }

  protected expanderLabel(expanded: boolean): string {
    return expanded ? 'Collapse row' : 'Expand row';
  }
}
